import { Box, CircularProgress } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { lazy, Suspense } from 'react';

const SignUp = lazy(() => import('pages/sign-up'));

const Loader = (): JSX.Element => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
    <CircularProgress />
  </Box>
);

export const Route = createFileRoute('/_public/_landing/sign-up')({
  component: SignUpWrapper,
});

function SignUpWrapper(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <SignUp />
    </Suspense>
  );
}
